import React, { useState } from 'react'
import { Sidebar } from 'src/components/app-shell/Sidebar'
import Header from './Header'
import Footer from './Footer'
import CommandPalette from '../CommandPalette'

export function AppShell({ children, menus = [] }) {
  const [commandOpen, setCommandOpen] = useState(false)

  return (
    <div className="h-screen flex bg-background overflow-hidden">
      {/* Command Palette */}
      <CommandPalette open={commandOpen} setOpen={setCommandOpen} menus={menus} />

      {/* Sidebar (seamless, inherits parent bg) */}
      <Sidebar />

      {/* Right column */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header (seamless, same bg as parent) */}
        <Header setCommandOpen={setCommandOpen} />

        {/* Content - white card nested inside */}
        <main className="flex-1 overflow-y-auto bg-card text-card-foreground rounded-2xl shadow-sm m-4 mt-0 p-6">
          {children}
          <Footer />
        </main>
      </div>
    </div>
  )
}

export default AppShell
